import React from "react"

import useModelViewPing from "Pods/ThreeDStudio/Hooks/useModelViewPing"
import usePersistCameraPose from "Pods/ThreeDStudio/Hooks/usePersistCameraPose"
import LoadingState from "Pods/ThreeDStudio/Shared/LoadingState/LoadingState"
import { isAnimationModel } from "Pods/ThreeDStudio/Shared/Utils/isAnimationModel"
import { useViewerContext } from "Pods/ThreeDStudio/Shared/ViewerContext/ViewerContext"
import { useThreeDStudioStore } from "Pods/ThreeDStudio/Store"

import AnimationPlayer from "./Components/AnimationPlayer/AnimationPlayer"
import EnvironmentSettings from "./Components/EnvironmentSettings/EnvironmentSettings"
import InnerViewerSidebar from "./Components/InnerViewerSidebar/InnerViewerSidebar"
import ModelDetailsCard from "./Components/ModelDetailsCard/ModelDetailsCard"
import ModelFeedback from "./Components/ModelFeedback/ModelFeedback"
import RenderModeSelector from "./Components/RenderModeSelector/RenderModeSelector"
import useEnvironmentSettingsPopover from "./Hooks/useEnvironmentSettingsPopover"
import useModelLoader from "./Hooks/useModelLoader"

function ViewerContent() {
  const environmentSettings = useEnvironmentSettingsPopover()
  const viewer = useViewerContext()
  usePersistCameraPose(viewer)
  const { isLoading, isOpenedRunOnScreen } = useModelLoader(viewer)
  useModelViewPing({ enabled: isOpenedRunOnScreen })
  const openedModelId = useThreeDStudioStore(state => state.ui?.openedModel?.providerModelId)
  const isSwapping = useThreeDStudioStore(state => state.staticViewer?.isSwapping)

  return (
    <>
      <RenderModeSelector />
      <ModelDetailsCard />
      <EnvironmentSettings isOpen={environmentSettings.isOpen} />
      <InnerViewerSidebar
        isEnvironmentSettingsOpen={environmentSettings.isOpen}
        onEnvironmentSettingsClick={environmentSettings.toggle}
      />
      {isAnimationModel(openedModelId) && <AnimationPlayer />}
      {isLoading && <LoadingState isOverModel={Boolean(isSwapping)} />}
      {isOpenedRunOnScreen && <ModelFeedback />}
    </>
  )
}

export default ViewerContent
